/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object"

export default ($axios: any): any => ({
  // 인스타그램 포스팅 목록
  async index(data?: any) {
    return camelize(await $axios.get(`/instagram`, snakelize({ params: data })))
  }
})
